import { cn } from '@/lib/utils';
import type { MouseEvent } from 'react';

interface Props {
  onMouseDown: (e: MouseEvent) => void;
  className?: string;
}

/** A 4px draggable vertical divider between panes. */
export function PaneResizer({ onMouseDown, className }: Props) {
  return (
    <div
      onMouseDown={onMouseDown}
      className={cn(
        'w-1 shrink-0 cursor-col-resize bg-(--color-border) transition-colors hover:bg-(--color-green)',
        className,
      )}
    />
  );
}
